import { ErrorBoundary } from '@webapp/components/ErrorBoundary'
import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import messages from './messages'
import { type ISpendTrackerProps, SpendTracker } from './SpendTracker'
import { type ISheetProps, Sheet } from '../../Sheet'

export interface ISpendTrackerSheetProps extends ISpendTrackerProps {
  isOpen: boolean
  onDismiss: () => void
  container?: ISheetProps['container']
}

export const SpendTrackerSheet = ({
  isOpen = true,
  onDismiss,
  container,
  ...spendTrackerProps
}: ISpendTrackerSheetProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  if (!isOpen) return null

  return (
    <Sheet isOpen={isOpen} container={container}>
      <Sheet.Header
        onDismiss={onDismiss}
        iconButtonLabel={intl.formatMessage(
          FT_5817_ENABLE_BUDGETS_REDESIGN
            ? messages.hideBudgetTrackerButtonLabel
            : messages.hideSpendTrackerButtonLabel
        )}
      >
        {intl.formatMessage(
          FT_5817_ENABLE_BUDGETS_REDESIGN
            ? messages.budgetTrackerHeader
            : messages.spendTrackerHeader
        )}
      </Sheet.Header>
      <Sheet.Content>
        <ErrorBoundary boundaryName='SpendTrackerSheet'>
          <SpendTracker {...spendTrackerProps} />
        </ErrorBoundary>
      </Sheet.Content>
    </Sheet>
  )
}

SpendTrackerSheet.displayName = 'SpendTrackerSheet'
